export default __webpack_public_path__ + "static/media/onboarding-step-1.0468131b.png";